module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Status")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.canEditStatus) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5 readonly-form",
    class: {
      'readonly-form--blocked': !_vm.canEditStatus
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.listaStatus,
      "name": "status",
      "data-vv-as": "status",
      "error-messages": _vm.errors.has('status') ? _vm.errors.first('status') : [],
      "label": "Selecione um status"
    },
    model: {
      value: (_vm.form.fields.status),
      callback: function($$v) {
        _vm.form.fields.status = $$v
      },
      expression: "form.fields.status"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.status === 'Vago') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    staticClass: "switch-fix mb-5",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [(_vm.form.fields.vago_com_placa) ? _c('span', [_vm._v("Com")]) : _c('span', [_vm._v("Sem")]), _vm._v(" placa")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.vago_com_placa),
      callback: function($$v) {
        _vm.form.fields.vago_com_placa = $$v
      },
      expression: "form.fields.vago_com_placa"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaSeguranca,
      "name": "vago_seguranca",
      "label": "Nível de segurança"
    },
    model: {
      value: (_vm.form.fields.vago_seguranca),
      callback: function($$v) {
        _vm.form.fields.vago_seguranca = $$v
      },
      expression: "form.fields.vago_seguranca"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Observações de segurança",
      "name": "vago_seguranca_observacoes"
    },
    model: {
      value: (_vm.form.fields.vago_seguranca_observacoes),
      callback: function($$v) {
        _vm.form.fields.vago_seguranca_observacoes = $$v
      },
      expression: "form.fields.vago_seguranca_observacoes"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.status === 'Compromissado') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaCondicao,
      "name": "compromissado_condicao",
      "label": "Condição"
    },
    model: {
      value: (_vm.form.fields.compromissado_condicao),
      callback: function($$v) {
        _vm.form.fields.compromissado_condicao = $$v
      },
      expression: "form.fields.compromissado_condicao"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.compromissado_condicao === 'Inadimplente') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-top": 400,
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.compromissadoInadimplenteDataMenu),
      callback: function($$v) {
        _vm.compromissadoInadimplenteDataMenu = $$v
      },
      expression: "compromissadoInadimplenteDataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data da inadimplência",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.compromissado_inadimplente_data_formatada),
      callback: function($$v) {
        _vm.form.fields.compromissado_inadimplente_data_formatada = $$v
      },
      expression: "form.fields.compromissado_inadimplente_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.compromissado_inadimplente_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.compromissado_inadimplente_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.compromissado_inadimplente_data),
      callback: function($$v) {
        _vm.form.fields.compromissado_inadimplente_data = $$v
      },
      expression: "form.fields.compromissado_inadimplente_data"
    }
  })], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.compromissado_condicao === 'Inadimplente ajuizado') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do cliente/caso"
    },
    model: {
      value: (_vm.form.fields.compromissado_ajuizado_cliente),
      callback: function($$v) {
        _vm.form.fields.compromissado_ajuizado_cliente = $$v
      },
      expression: "form.fields.compromissado_ajuizado_cliente"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do processo/execução"
    },
    model: {
      value: (_vm.form.fields.compromissado_ajuizado_processo),
      callback: function($$v) {
        _vm.form.fields.compromissado_ajuizado_processo = $$v
      },
      expression: "form.fields.compromissado_ajuizado_processo"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do comprador",
      "name": "compromissado_comprador"
    },
    model: {
      value: (_vm.form.fields.compromissado_comprador),
      callback: function($$v) {
        _vm.form.fields.compromissado_comprador = $$v
      },
      expression: "form.fields.compromissado_comprador"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-top": 400,
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.compromissadoDataMenu),
      callback: function($$v) {
        _vm.compromissadoDataMenu = $$v
      },
      expression: "compromissadoDataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data do compromisso",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.compromissado_data_formatada),
      callback: function($$v) {
        _vm.form.fields.compromissado_data_formatada = $$v
      },
      expression: "form.fields.compromissado_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.compromissado_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.compromissado_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.compromissado_data),
      callback: function($$v) {
        _vm.form.fields.compromissado_data = $$v
      },
      expression: "form.fields.compromissado_data"
    }
  })], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.status === 'Locado') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaCondicao,
      "name": "locado_condicao",
      "label": "Condição"
    },
    model: {
      value: (_vm.form.fields.locado_condicao),
      callback: function($$v) {
        _vm.form.fields.locado_condicao = $$v
      },
      expression: "form.fields.locado_condicao"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.locado_condicao === 'Inadimplente') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-top": 400,
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.locadoInadimplenteDataMenu),
      callback: function($$v) {
        _vm.locadoInadimplenteDataMenu = $$v
      },
      expression: "locadoInadimplenteDataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data da inadimplência",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.locado_inadimplente_data_formatada),
      callback: function($$v) {
        _vm.form.fields.locado_inadimplente_data_formatada = $$v
      },
      expression: "form.fields.locado_inadimplente_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.locado_inadimplente_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.locado_inadimplente_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.locado_inadimplente_data),
      callback: function($$v) {
        _vm.form.fields.locado_inadimplente_data = $$v
      },
      expression: "form.fields.locado_inadimplente_data"
    }
  })], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.locado_condicao === 'Inadimplente ajuizado') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do cliente/caso"
    },
    model: {
      value: (_vm.form.fields.locado_ajuizado_cliente),
      callback: function($$v) {
        _vm.form.fields.locado_ajuizado_cliente = $$v
      },
      expression: "form.fields.locado_ajuizado_cliente"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do processo/execução"
    },
    model: {
      value: (_vm.form.fields.locado_ajuizado_processo),
      callback: function($$v) {
        _vm.form.fields.locado_ajuizado_processo = $$v
      },
      expression: "form.fields.locado_ajuizado_processo"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do locador"
    },
    model: {
      value: (_vm.form.fields.locado_locador),
      callback: function($$v) {
        _vm.form.fields.locado_locador = $$v
      },
      expression: "form.fields.locado_locador"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do locatário"
    },
    model: {
      value: (_vm.form.fields.locado_locatario),
      callback: function($$v) {
        _vm.form.fields.locado_locatario = $$v
      },
      expression: "form.fields.locado_locatario"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: ('money'),
      expression: "'money'"
    }],
    attrs: {
      "label": "Valor do aluguel",
      "name": "locado_valor"
    },
    model: {
      value: (_vm.form.fields.locado_valor),
      callback: function($$v) {
        _vm.form.fields.locado_valor = $$v
      },
      expression: "form.fields.locado_valor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-top": 400,
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.locadoValorDataMenu),
      callback: function($$v) {
        _vm.locadoValorDataMenu = $$v
      },
      expression: "locadoValorDataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data do valor do aluguel",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.locado_valor_data_formatada),
      callback: function($$v) {
        _vm.form.fields.locado_valor_data_formatada = $$v
      },
      expression: "form.fields.locado_valor_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.locado_valor_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.locado_valor_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.locado_valor_data),
      callback: function($$v) {
        _vm.form.fields.locado_valor_data = $$v
      },
      expression: "form.fields.locado_valor_data"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-top": 400,
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.locadoInicioDataMenu),
      callback: function($$v) {
        _vm.locadoInicioDataMenu = $$v
      },
      expression: "locadoInicioDataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data do início do contrato",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.locado_inicio_data_formatada),
      callback: function($$v) {
        _vm.form.fields.locado_inicio_data_formatada = $$v
      },
      expression: "form.fields.locado_inicio_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.locado_inicio_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.locado_inicio_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.locado_inicio_data),
      callback: function($$v) {
        _vm.form.fields.locado_inicio_data = $$v
      },
      expression: "form.fields.locado_inicio_data"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-top": 400,
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.locadoFimDataMenu),
      callback: function($$v) {
        _vm.locadoFimDataMenu = $$v
      },
      expression: "locadoFimDataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data do fim do contrato",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.locado_fim_data_formatada),
      callback: function($$v) {
        _vm.form.fields.locado_fim_data_formatada = $$v
      },
      expression: "form.fields.locado_fim_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.locado_fim_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.locado_fim_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.locado_fim_data),
      callback: function($$v) {
        _vm.form.fields.locado_fim_data = $$v
      },
      expression: "form.fields.locado_fim_data"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix mb-5",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Ação renovatória")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.locado_acao_renovatoria),
      callback: function($$v) {
        _vm.form.fields.locado_acao_renovatoria = $$v
      },
      expression: "form.fields.locado_acao_renovatoria"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.locado_acao_renovatoria) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº da ação renovatória"
    },
    model: {
      value: (_vm.form.fields.locado_acao_renovatoria_numero),
      callback: function($$v) {
        _vm.form.fields.locado_acao_renovatoria_numero = $$v
      },
      expression: "form.fields.locado_acao_renovatoria_numero"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do cliente/caso"
    },
    model: {
      value: (_vm.form.fields.locado_acao_renovatoria_cliente),
      callback: function($$v) {
        _vm.form.fields.locado_acao_renovatoria_cliente = $$v
      },
      expression: "form.fields.locado_acao_renovatoria_cliente"
    }
  })], 1)], 1) : _vm._e()])], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.status === 'Comodato') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "name": "comodato_nome"
    },
    model: {
      value: (_vm.form.fields.comodato_nome),
      callback: function($$v) {
        _vm.form.fields.comodato_nome = $$v
      },
      expression: "form.fields.comodato_nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "RG",
      "name": "comodato_rg"
    },
    model: {
      value: (_vm.form.fields.comodato_rg),
      callback: function($$v) {
        _vm.form.fields.comodato_rg = $$v
      },
      expression: "form.fields.comodato_rg"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        regex: /[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}/
      }),
      expression: "{ regex: /[0-9]{3}\\.?[0-9]{3}\\.?[0-9]{3}\\-?[0-9]{2}/ }"
    }],
    attrs: {
      "label": "CPF",
      "name": "comodato_cpf",
      "data-vv-delay": "300",
      "data-vv-as": "CPF",
      "error-messages": _vm.errors.has('comodato_cpf') ? _vm.errors.first('comodato_cpf') : []
    },
    model: {
      value: (_vm.form.fields.comodato_cpf),
      callback: function($$v) {
        _vm.form.fields.comodato_cpf = $$v
      },
      expression: "form.fields.comodato_cpf"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.form.fields.comodato_telefone), function(item, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs12": ""
      }
    }, [_c('v-text-field', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (['(##) ####-####', '(##) #####-####']),
        expression: "['(##) ####-####', '(##) #####-####']"
      }],
      attrs: {
        "prepend-icon": "phone",
        "append-icon": _vm.appendIcon(index),
        "append-icon-cb": _vm.adicionarRemoverTelefone.bind(this, index, _vm.form.fields.comodato_telefone),
        "label": "Telefone",
        "name": "comodato_telefone"
      },
      model: {
        value: (_vm.form.fields.comodato_telefone[index].numero),
        callback: function($$v) {
          _vm.form.fields.comodato_telefone[index].numero = $$v
        },
        expression: "form.fields.comodato_telefone[index].numero"
      }
    })], 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.status === 'Invadido') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "name": "invadido_nome"
    },
    model: {
      value: (_vm.form.fields.invadido_nome),
      callback: function($$v) {
        _vm.form.fields.invadido_nome = $$v
      },
      expression: "form.fields.invadido_nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "RG",
      "name": "invadido_rg"
    },
    model: {
      value: (_vm.form.fields.invadido_rg),
      callback: function($$v) {
        _vm.form.fields.invadido_rg = $$v
      },
      expression: "form.fields.invadido_rg"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        regex: /[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}/
      }),
      expression: "{ regex: /[0-9]{3}\\.?[0-9]{3}\\.?[0-9]{3}\\-?[0-9]{2}/ }"
    }],
    attrs: {
      "label": "CPF",
      "name": "invadido_cpf",
      "data-vv-delay": "300",
      "data-vv-as": "CPF",
      "error-messages": _vm.errors.has('invadido_cpf') ? _vm.errors.first('invadido_cpf') : []
    },
    model: {
      value: (_vm.form.fields.invadido_cpf),
      callback: function($$v) {
        _vm.form.fields.invadido_cpf = $$v
      },
      expression: "form.fields.invadido_cpf"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.form.fields.invadido_telefone), function(item, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs12": ""
      }
    }, [_c('v-text-field', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: (['(##) ####-####', '(##) #####-####']),
        expression: "['(##) ####-####', '(##) #####-####']"
      }],
      attrs: {
        "prepend-icon": "phone",
        "append-icon": _vm.appendIcon(index),
        "append-icon-cb": _vm.adicionarRemoverTelefone.bind(this, index, _vm.form.fields.invadido_telefone),
        "label": "Telefone",
        "name": "invadido_telefone"
      },
      model: {
        value: (_vm.form.fields.invadido_telefone[index].numero),
        callback: function($$v) {
          _vm.form.fields.invadido_telefone[index].numero = $$v
        },
        expression: "form.fields.invadido_telefone[index].numero"
      }
    })], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-top": 400,
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.invadidoDataMenu),
      callback: function($$v) {
        _vm.invadidoDataMenu = $$v
      },
      expression: "invadidoDataMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Data estimada da invasão",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.invadido_data_formatada),
      callback: function($$v) {
        _vm.form.fields.invadido_data_formatada = $$v
      },
      expression: "form.fields.invadido_data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.invadido_data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.invadido_data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.invadido_data),
      callback: function($$v) {
        _vm.form.fields.invadido_data = $$v
      },
      expression: "form.fields.invadido_data"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaCondicao,
      "name": "invadido_condicao",
      "label": "Condição"
    },
    model: {
      value: (_vm.form.fields.invadido_condicao),
      callback: function($$v) {
        _vm.form.fields.invadido_condicao = $$v
      },
      expression: "form.fields.invadido_condicao"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [(_vm.form.fields.invadido_condicao === 'Ocupado ajuizado') ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do cliente/caso"
    },
    model: {
      value: (_vm.form.fields.invadido_ajuizado_cliente),
      callback: function($$v) {
        _vm.form.fields.invadido_ajuizado_cliente = $$v
      },
      expression: "form.fields.invadido_ajuizado_cliente"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº do processo/execução"
    },
    model: {
      value: (_vm.form.fields.invadido_ajuizado_processo),
      callback: function($$v) {
        _vm.form.fields.invadido_ajuizado_processo = $$v
      },
      expression: "form.fields.invadido_ajuizado_processo"
    }
  })], 1)], 1) : _vm._e()])], 2) : _vm._e()])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('ButtonsObservacoesAnexos')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b6a47ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Detalhes/DetalhesStatus.vue
// module id = 1038
// module chunks = 1